import { norwegianGroceries } from './norwegian/groceries.js';
import { norwegianHousehold } from './norwegian/household.js';
import { norwegianTech } from './norwegian/tech.js';
import { englishGroceries } from './english/groceries.js';
import { englishHousehold } from './english/household.js';
import { englishTech } from './english/tech.js';

// Available languages
export const LANGUAGES = {
  NO: 'no',
  EN: 'en'
};

// Available template types
export const TEMPLATE_TYPES = {
  GROCERIES: 'groceries',
  HOUSEHOLD: 'household',
  TECH: 'tech'
};

// Main seed templates organized by language and type
export const seedTemplates = {
  [LANGUAGES.NO]: {
    [TEMPLATE_TYPES.GROCERIES]: norwegianGroceries,
    [TEMPLATE_TYPES.HOUSEHOLD]: norwegianHousehold,
    [TEMPLATE_TYPES.TECH]: norwegianTech
  },
  [LANGUAGES.EN]: {
    [TEMPLATE_TYPES.GROCERIES]: englishGroceries,
    [TEMPLATE_TYPES.HOUSEHOLD]: englishHousehold,
    [TEMPLATE_TYPES.TECH]: englishTech
  }
};

// Helper function to get all available templates for a language
export const getTemplatesForLanguage = (language) => {
  return seedTemplates[language] || {};
};

// Helper function to get a specific template
export const getTemplate = (language, templateType) => {
  return seedTemplates[language]?.[templateType] || null;
};

// Helper function to get all available languages
export const getAvailableLanguages = () => {
  return Object.keys(seedTemplates).map(langCode => ({
    code: langCode,
    name: getLanguageName(langCode),
    flag: getLanguageFlag(langCode)
  }));
};

// Helper function to get language display name
export const getLanguageName = (langCode) => {
  const names = {
    [LANGUAGES.NO]: 'Norsk',
    [LANGUAGES.EN]: 'English'
  };
  return names[langCode] || langCode;
};

// Helper function to get language flag emoji
export const getLanguageFlag = (langCode) => {
  const flags = {
    [LANGUAGES.NO]: '🇳🇴',
    [LANGUAGES.EN]: '🇬🇧'
  };
  return flags[langCode] || '🌍';
};

// Helper function to get all template types for a language
export const getTemplateTypesForLanguage = (language) => {
  const templates = getTemplatesForLanguage(language);
  return Object.keys(templates).map(templateType => ({
    type: templateType,
    template: templates[templateType]
  }));
};
